<template>
    <div v-if="$store.getters.agent && !$store.getters.isMobile" class="home flex-row">
        <!-- <div class="flex-fill first-section">
            <Notices class="flex-fill" :passedNtype="'notices'" />
        </div>
        <div class="flex-fill middle-section">
            <AmpuRanking />
        </div> -->
        <!-- <div class="flex-wrap second-section">
            <TotalRanking class="m-b-16" />
        </div> -->
    </div>
    <!-- <div v-else-if="$store.getters.agent && $store.getters.isMobile" class="home flex">
        <Notices class="flex-wrap" :passedNtype="'notices'" v-if="!$isTester()" />
        <TotalRanking class="flex-wrap" v-if="!$isTester()" />
    </div> -->
</template>

<script>
// import Notices from './Notices'
// import TotalRanking from './TotalRanking'
// import AmpuRanking from '@/routes/home/AmpuRanking'

export default {
    name: 'HomePage',
    components: {
        // Notices,
        // TotalRanking,
        // AmpuRanking,
    },
}
</script>
